<template>
  <div class="cases grey-bg2 wow fadeInUp2 animated project-card" data-wow-delay=".3s">
    <div class="cases__box pos-rel card-image">
      <div class="cases__box--img">
        <router-link :to="projectLink">
          <img :src="row.image ? row.image.url : placeholder" :alt="row.title" class="img-box-500" loading="lazy"
            @error="handleImageError" />
        </router-link>
      </div>
    </div>
    <div class="cases__content">
      <ul class="cases__tag white-bg project-card-badges">
        <li>
          <div class="cases--author d-flex align-items-center">
            <div v-if="row.country" class="project-card-country">
              <flag :iso="row.country.ccode" style="font-size: 18px; border-radius: 50%" />
              <h4 class="semi-02-title ml-15" style="font-size: 13px">
                {{ row.country.name }}
              </h4>
            </div>
            <span v-if="row.main_category" class="project-card-category">{{ shortlen(row.main_category.name, 12) }}</span>
          </div>
        </li>
      </ul>
      <router-link :to="projectLink">
        <h5>{{ shortlen(row.title, 60) }}</h5>
      </router-link>

      <div class="cases-progress">
        <div class="project-card-progress">
          <h5 class="text-start">{{ percentage }}%</h5>
          <div class="progress">
            <div class="progress-bar wow fadeInLeft animated" data-wow-delay="0.3s" role="progressbar"
              :style="{ width: percentage + '%' }" :aria-valuenow="percentage" aria-valuemin="0" aria-valuemax="100">
            </div>
          </div>
        </div>
        <div class="project-card-stats">
          <div class="text-center">
            <p>{{ $t("app.target") }}</p>
            <span>{{ row.target }} {{ $t("app.dinar") }}</span>
          </div>
          <div class="text-center">
            <p>{{ $t('app.paidMoney') }}</p>
            <span>{{ row.paid || 0 }} {{ $t('app.kw') }}</span>
          </div>
          <div class="text-center">
            <p>{{ $t('app.remainMoney') }}</p>
            <span>{{ row.remain != null ? row.remain : row.target }} {{ $t('app.kw') }}</span>
          </div>
        </div>

        <div class="case-btns d-flex justify-content-center">
          <router-link :to="projectLink" class="theme_btn theme_btn_bg">
            {{ $t("app.donate_Now") }}
            <span :style="[locale == 'en' ? { left: 'auto' } : {}]"><i class="fas fa-angle-double-left"></i></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectCard",
  props: {
    row: { type: Object, required: true },
  },
  data() {
    return {
      locale: localStorage.getItem("locale") || "ar",
      placeholder: "/assets/img/logo/min-logo.png",
    };
  },
  computed: {
    projectLink() {
      return { name: "show-projects", params: { slug: this.row.slug, id: this.row.id } };
    },
    percentage() {
      return Number(this.row.percentage) || 0;
    },
  },
  methods: {
    handleImageError(event) {
      event.target.src = this.placeholder;
    },
    shortlen(string, len) {
      if (!string) return "";
      let dots = "";
      if (string.length > len) {
        dots = "...";
      }
      return (
        string.substring(0, len + string.substring(len - 1).indexOf(" ")) + dots
      );
    },
  },
};
</script>

<style scoped>
.project-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: 0;
  overflow: hidden;
  border-radius: 15px;
  background: #fff;
  border: 1px solid #edf0f3;
  box-shadow: 0 4px 16px rgba(0, 18, 52, 0.06);
  transition: box-shadow 0.2s ease;
}

.project-card:hover {
  box-shadow: 0 8px 24px rgba(0, 18, 52, 0.1);
}

.project-card .cases__box {
  border-radius: 15px 15px 0 0;
  overflow: hidden;
}

.project-card .cases__box--img a {
  display: block;
}

.project-card .cases__box--img img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 5 / 4;
  object-fit: cover;
}

.project-card:hover .cases__box--img img {
  transform: none;
}

.project-card .cases__content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 14px;
  padding: 18px;
}

.project-card .project-card-badges {
  position: static;
  height: auto;
  margin: 0;
  padding: 0;
  border-radius: 0;
  background: transparent;
}

.project-card .cases--author {
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
}

.project-card .project-card-country,
.project-card .project-card-category {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #f8f9fa;
  color: #001234;
  font-size: 12px;
  line-height: 1.5;
}

.project-card .project-card-country h4 {
  margin: 0;
  line-height: 1.5;
  font-weight: 600;
}

.project-card .project-card-category {
  background: rgba(31, 148, 209, 0.08);
  color: #1f94d1;
}

.project-card .cases__content > a > h5 {
  min-height: 3.2em;
  margin: 0;
  color: #001234;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.6;
  text-align: start;
  overflow-wrap: anywhere;
}

.project-card .cases-progress {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 16px;
}

.project-card .project-card-progress {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
}

.project-card .project-card-progress h5 {
  margin: 0;
  color: #f8327d;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.5;
}

.project-card .progress {
  height: 6px;
  overflow: hidden;
  border-radius: 6px;
  background: #f1f3f5;
}

.project-card .progress-bar {
  border-radius: inherit;
  background: #f8327d;
}

.project-card .project-card-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding-block: 12px;
  border-block: 1px solid #edf0f3;
}

.project-card .project-card-stats > .text-center {
  padding-inline: 5px;
}

.project-card .project-card-stats > .text-center ~ .text-center {
  border-inline-start: 1px solid #edf0f3;
}

.project-card .project-card-stats p {
  margin: 0 0 4px;
  color: #6c757d;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.6;
}

.project-card .project-card-stats span {
  color: #001234;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.project-card .case-btns {
  margin-top: auto;
}

.project-card .case-btns > .theme_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 46px;
  margin: 0;
  padding: 10px 16px;
  border-radius: 12px;
}

.project-card .case-btns > .theme_btn::before {
  border-radius: inherit;
}

.project-card .case-btns > .theme_btn span {
  position: static;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  line-height: 26px;
}

.project-card .case-btns > .theme_btn span i {
  font-size: 12px;
  line-height: 26px;
}

.project-card a:focus-visible {
  outline: 2px solid #1f94d1;
  outline-offset: -2px;
}

@media (prefers-reduced-motion: reduce) {
  .project-card {
    transition: none;
  }
}
</style>
